import { useCallback } from "react";
import LoginWithEmail from "./Login/LoginWithEmail";
import ResetPassword from "./Login/ResetPassword";
import AuthMoveBack from "./AuthMoveBack/AuthMoveBack";
import authPopupClasses from "./AuthPopup.module.scss";

interface IAuthLoginProps {
  currentStep: number;
  prev: (decrement?: number) => void;
  next: (increment?: number) => void;
  onClose: () => void;
}

const STEP_TITLES = [
  "Login with email",
  "Forgot password?",
];

const LOGIN_WITH_EMAIL = 0;
const RESET_PASSWORD = 1;

const AuthLogin = ({ currentStep, prev, next, onClose }: IAuthLoginProps) => {
  const handleNext = useCallback(() => {
    next();
  }, [next]);

  const handleBack = useCallback(() => {
    prev();
  }, [prev]);

  return (
    <div className={authPopupClasses.ContentContainer}>
      {currentStep !== 0 && (
        <AuthMoveBack back={handleBack} text={STEP_TITLES[currentStep]}/>
      )}

      {currentStep === LOGIN_WITH_EMAIL && (
        <LoginWithEmail next={handleNext} />
      )}

      {currentStep === RESET_PASSWORD && (
        <ResetPassword onClose={onClose} />
      )}
    </div>
  );
};

export default AuthLogin;
